var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMenu = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.6,
    height: 15.6,
    viewBox: "0 0 19.6 15.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-746.44 -14.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.24,16.18h18a.8.8,0,0,0,0-1.6h-18a.8.8,0,0,0,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.24,21.58h-18a.8.8,0,0,0,0,1.6h18a.8.8,0,0,0,0-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.24,28.58h-18a.8.8,0,0,0,0,1.6h18a.8.8,0,0,0,0-1.6Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.b74f527b.svg";
export { ForwardRef as ReactComponent };